import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { register } from 'swiper/element/bundle';
import { UnAuthorizedApiInterceptor } from './core/interceptors/unauthorized.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { PeticionesInterceptor } from '@core/interceptors/peticiones.interceptor';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
	StoreEffects,
	AuthEffects,
	CartEffects,
	CheckoutEffects,
	StatusEffects,
	LocalChannelEffects,
	CoreEffects,
	NotificationEffects,
	CategoryEffects,
	PayEffects,
	CreditCardVaultEffects,
	TipEffects,
	ClientEffects,
	DeliveryZoneCustomerEffects,
	DeliveryZoneEffects,
	OrderTypeEffects,
	CouponEffects,
	ConfiguracionCanalEffects,
	ProductEffects,
	SubcategoryEffects,
	MenuEffects,
	AvailabilityEffects,
	StoreArgentinaEffects,
	DualPricingEffects,
} from '@store/effects';
import { reducers } from '@store/reducers';
import { environment } from '@environments/environment';
import { WorkDayEffects } from '@store/effects/work-day.effects';
import { ShoppingcartComponent } from './features/shoppingcart/shoppingcart.component';
import { CartsComponent } from './shared/components/cart-items/cart-items.component';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { SummaryComponent } from './features/checkout/components/summary/summary.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { ScreenLoadingComponent } from '@shared/components/screen-loading/screen-loading.component';
import { AuthModule } from './features/auth/auth-module';
import { ButtonComponent, SwitchComponent } from './shared/components';
import { ThemeService } from './core/services';
import { IconComponent } from './shared/components/icon/icon.component';
import { metaReducers } from './store/reducers/storage-reducers';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';

register();

@NgModule({
	declarations: [AppComponent, ShoppingcartComponent],
	imports: [
		BrowserModule,
		RouterModule,
		IonicModule.forRoot({
			mode: 'md',
		}),
		AppRoutingModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		EffectsModule.forRoot([
			AuthEffects,
			PayEffects,
			CheckoutEffects,
			CartEffects,
			StoreEffects,
			StatusEffects,
			CreditCardVaultEffects,
			LocalChannelEffects,
			CoreEffects,
			NotificationEffects,
			CategoryEffects,
			TipEffects,
			WorkDayEffects,
			ClientEffects,
			DeliveryZoneCustomerEffects,
			DeliveryZoneEffects,
			OrderTypeEffects,
			CouponEffects,
			ConfiguracionCanalEffects,
			ProductEffects,
			SubcategoryEffects,
			MenuEffects,
			AvailabilityEffects,
			StoreArgentinaEffects,
			DualPricingEffects,
		]),
		NotificationComponent,
		// Habilita Redux DevTools solo en modo de desarrollo
		StoreDevtoolsModule.instrument({
			maxAge: 25, // Número de acciones a mantener en el historial
			logOnly: environment.production, // Solo permite logging si es producción
			serialize: {
				replacer: (_: unknown, value: bigint | number | string) => {
					if (!(typeof value === 'bigint')) return value;

					return value.toString();
				},
			},
		}),
		CartsComponent,
		LoadingComponent,
		SummaryComponent,
		ScreenLoadingComponent,
		AuthModule,
		ButtonComponent,
		IconComponent,
		SwitchComponent,
	],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		{ provide: HTTP_INTERCEPTORS, useClass: PeticionesInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: UnAuthorizedApiInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideDatabase(() => getDatabase()),
		provideAppInitializer(() => {
			const themeService = inject(ThemeService);
			themeService.init();
		}),
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
